// AI yechimlar (sun'iy intellekt) — xizmat sahifasi kontenti

const uz = {
    meta: {
        title: "AI yechimlar — biznes uchun sun'iy intellekt joriy etish",
        description:
            "Biznes uchun AI yechimlar: hujjat tahlili, bashorat modellari, tavsiya tizimlari va RAG bilimlar bazasi. Narxi 18 mln so'mdan, muddat 3 haftadan. Innobek, Toshkent.",
        keywords: [
            "AI yechimlar",
            "sun'iy intellekt",
            "biznes uchun AI",
            "RAG bilimlar bazasi",
            "hujjat tahlili AI",
            "bashorat modeli",
            "tavsiya tizimi",
            "sun'iy intellekt narxi",
            "Claude API",
            "vektor baza",
        ],
    },

    hero: {
        eyebrow: "Sun'iy intellekt / AI yechimlar",
        h1: "AI yechimlar — sizning ma'lumotlaringiz asosida ishlaydigan sun'iy intellekt",
        lead:
            "Kompaniyada yillar davomida to'plangan hujjat, shartnoma, buyurtma va yozishmalar bor. Ularning ichidagi javob odamga soatlab qidirish kerak bo'ladi. AI yechim shu javobni soniyalarda topadi, manbasini ko'rsatadi va bilmagan joyida to'xtaydi.",
        ctaPrimary: "Bepul konsultatsiya olish",
        ctaSecondary: "Narxlarni ko'rish",
        proof: [
            "Toshkentda ishlab chiqish jamoasi",
            "Claude API va OpenAI API bilan ishlaymiz",
            "O'zbek va rus tilidagi hujjatlar",
            "Har javob manba bilan ko'rsatiladi",
            "Pilotdan boshlaymiz — katta byudjetsiz",
        ],
    },

    intro: {
        h: "AI yechim nima va u qachon haqiqatan foyda beradi?",
        p: [
            "Ko'pchilik \"sun'iy intellekt\" deganda chatbotni tushunadi. Aslida biznes uchun AI yechimlar ancha keng: hujjatdan ma'lumot ajratib olish, sotuvni bashorat qilish, mijozga mahsulot tavsiya qilish, ichki bilimlar bazasidan javob topish. Bularning har biri alohida vazifa va alohida arxitektura talab qiladi.",
            "Biz AI'ni sehr sifatida sotmaymiz. Model o'zidan bilim ixtiro qilmaydi — u faqat siz bergan ma'lumot ustida ishlaydi. Shuning uchun har loyiha ma'lumotni yig'ish va tartibga solishdan boshlanadi. Agar narxlar Excel'da beshta har xil versiyada yotgan bo'lsa, AI ham xato javob beradi. Buni oldindan aytamiz, keyin emas.",
            "Eng ko'p so'raladigan yechim — RAG (Retrieval-Augmented Generation) bilimlar bazasi. Hujjatlaringiz bo'laklarga ajratiladi, vektor bazaga (pgvector yoki Qdrant) yoziladi, savol kelganda tizim eng mos bo'laklarni topib modelga beradi. Model faqat shu bo'laklar asosida javob yozadi va oxirida qaysi hujjatning qaysi sahifasidan olganini ko'rsatadi.",
            "Ikkinchi katta yo'nalish — hujjat oqimini avtomatlashtirish. Shartnoma, hisob-faktura, akt, ariza — ularni odam ko'chirib yozadi. AI matnni o'qiydi, kerakli maydonlarni ajratadi va tizimga yozadi. Skanerlangan qog'oz bo'lsa OCR, ovozli murojaat bo'lsa Whisper qo'shiladi.",
            "Uchinchisi — raqamlar ustida ishlaydigan modellar: sotuv bashorati, ombor qoldig'i prognozi, mijoz ketib qolish ehtimoli, katalog uchun tavsiya tizimi. Bu yerda katta til modeli emas, klassik mashinali o'rganish ishlatiladi va natija aniq foizda o'lchanadi.",
        ],
    },

    definition: {
        term: "AI yechim nima?",
        text:
            "AI yechim — kompaniyaning o'z ma'lumotlari ustida ishlaydigan va aniq bir vazifani (hujjat tahlili, bashorat, tavsiya yoki bilimlar bazasidan javob topish) bajaradigan dasturiy tizim.",
    },

    included: {
        eyebrow: "Nimalar kiradi",
        h: "Har bir loyihaga standart tarzda kiradi",
        sub: "Bular alohida to'lanadigan qo'shimcha emas — bazaviy paketda ham bor.",
        items: [
            "Vazifani aniqlash: AI nimani hal qiladi va natija qanday o'lchanadi",
            "Ma'lumot auditi — qaysi manbalar bor, qaysilari yetishmaydi",
            "Ma'lumotni tozalash va bir formatga keltirish",
            "Model tanlash: Claude API, OpenAI API yoki o'z serveringizdagi model",
            "Prompt va javob qoidalarini yozish, chegaralarni belgilash",
            "Vektor baza sozlash (pgvector yoki Qdrant) va indekslash",
            "Javob sifatini sinash uchun test to'plami — kamida 100 ta savol",
            "Gallyutsinatsiyaga qarshi himoya: manba ko'rsatish va \"bilmayman\" javobi",
            "Mavjud tizimga ulash: sayt, CRM, 1C yoki ichki panel",
            "Admin panel — hujjatlarni yangilash va javoblarni tekshirish",
            "Xodimlar uchun qo'llanma va ishga tushirish treningi",
            "Oylik API xarajatining real o'lchovi va prognozi",
            "Ishga tushgandan keyin 6 oylik texnik qo'llab-quvvatlash",
        ],
    },

    benefits: {
        eyebrow: "Nega kerak",
        h: "Sun'iy intellekt biznesga nima beradi",
        sub: "Vaqt tejash emas — aniq o'lchanadigan natija. Quyida nima realligi yozilgan.",
        items: [
            {
                t: "Javob qidirish vaqti qisqaradi",
                d: "Ichki bilimlar bazasi bo'lgan kompaniyalarda xodim javobni hujjatlar ichidan 10–30 daqiqada topadi. RAG tizimi bilan bu 10–20 soniyaga tushadi va javob ostida manba havolasi turadi — xodim o'zi tekshira oladi.",
            },
            {
                t: "Hujjat kiritish qo'ldan olinadi",
                d: "Hisob-faktura yoki shartnomadan maydonlarni ko'chirish bitta hujjatga 5–15 daqiqa oladi. AI buni 10–20 soniyada bajaradi. Aniqlik odatda 90–97% — qolgan qismini odam tasdiqlaydi, shuning uchun tekshiruv ekrani majburiy.",
            },
            {
                t: "Bashorat raqamga asoslanadi",
                d: "Sotuv va ombor bashorati ko'pincha menejerning sezgisiga qurilgan. Model 2–3 yillik tarixdan mavsumiylik va trendni oladi. Real loyihalarda xatolik 10–25% oralig'ida bo'ladi — bu \"aniq bilish\" emas, lekin xarid rejasi uchun yetarli.",
            },
            {
                t: "Tavsiya tizimi o'rtacha chekni oshiradi",
                d: "Katalogda mingdan ortiq mahsulot bo'lsa, mijoz uchdan ortiq sahifani ko'rmaydi. Xarid tarixiga asoslangan tavsiya bloki odatda o'rtacha chekni 5–15% ga ko'taradi. Aniq raqam katalog sifati va trafik hajmiga bog'liq.",
            },
            {
                t: "Bilim odamda emas, tizimda qoladi",
                d: "Tajribali xodim ishdan ketsa, bilimi ham ketadi. Bilimlar bazasiga yozilgan reglament, kelishuv va nostandart holatlar tizimda qoladi. Yangi xodim savolini AI'dan so'raydi, hamkasbini chalg'itmaydi.",
            },
            {
                t: "Xarajat oldindan ko'rinadi",
                d: "Ishlab chiqish narxi bir martalik, API xarajati esa oylik va so'rovlar soniga bog'liq. Pilot bosqichda real so'rov hajmini o'lchaymiz va oylik xarajatni so'mda aniq ko'rsatamiz. Kutilmagan hisob chiqmaydi.",
            },
            {
                t: "Kichikdan boshlash mumkin",
                d: "AI loyihasini butun kompaniya bo'ylab boshlash shart emas. Bitta bo'lim va bitta vazifadan boshlaymiz, uch-to'rt haftada natijani ko'rasiz. Ishlamasa — yo'qotish 18 million so'm bilan cheklanadi, yuzlab million emas.",
            },
        ],
    },

    audience: {
        eyebrow: "Kimlarga mos",
        h: "Qanaqa kompaniyalar AI yechim buyurtma qiladi",
        sub: "Umumiy qoida: ma'lumot ko'p, takroriy ish ko'p va xato qimmatga tushadi.",
        items: [
            {
                t: "Yuridik va konsalting kompaniyalari",
                d: "Shartnoma va normativ hujjatlar arxivi katta. AI kerakli bandni topadi, xulosa yozadi va manbani ko'rsatadi.",
            },
            {
                t: "Savdo va distributsiya",
                d: "Ombor qoldig'i bashorati, xarid rejasi va katalog uchun tavsiya tizimi. Bu yerda samara to'g'ridan-to'g'ri pulda o'lchanadi.",
            },
            {
                t: "Klinika va laboratoriyalar",
                d: "Bemor hujjatlari va tahlil natijalarini tizimlashtirish, tibbiy protokollar bo'yicha ichki qidiruv. Tashxis AI zimmasiga yuklanmaydi.",
            },
            {
                t: "Logistika va yetkazib berish",
                d: "Yuk hujjatlarini avtomatik o'qish, marshrut va muddat bashorati, mijoz murojaatlarini turkumlash.",
            },
            {
                t: "Moliya va buxgalteriya xizmatlari",
                d: "Hisob-fakturalarni tanib olish, tranzaksiyalarni turkumlash, g'ayrioddiy operatsiyalarni belgilab qo'yish.",
            },
            {
                t: "Ta'lim va HR bo'limlari",
                d: "Ichki reglamentlar bo'yicha xodimlar uchun bilimlar bazasi, rezyumelarni dastlabki saralash, testlarni avtomatik tekshirish.",
            },
            {
                t: "Ishlab chiqarish korxonalari",
                d: "Uskuna hujjatlari va texnik reglamentlar bo'yicha qidiruv, nosozlik tarixidan xizmat ko'rsatish muddatini bashorat qilish.",
            },
        ],
    },

    pricing: {
        eyebrow: "Narxlar",
        h: "AI yechim narxi — uchta paket",
        sub: "Narx ishlab chiqish uchun bir martalik to'lanadi. API xarajati alohida va oylik.",
        note:
            "Narxlar 2026-yil uchun ko'rsatilgan, yakuniy hisob bepul konsultatsiyadan keyin tasdiqlanadi. Model API'sining oylik xarajati alohida: kichik hajmda (kuniga 200–500 so'rov) taxminan 300 000 – 1 200 000 so'm, o'rtacha hajmda 1 500 000 – 4 000 000 so'm atrofida bo'ladi. Bu pul to'g'ridan-to'g'ri provayderga (Anthropic yoki OpenAI) to'lanadi, biz ustiga foiz qo'shmaymiz. Pilot bosqichda real so'rov hajmini o'lchab, aniq raqamni beramiz.",
        tiers: [
            {
                name: "Pilot",
                tagline: "Bitta aniq vazifa, tez natija",
                price: "18 000 000",
                priceNote: "so'mdan",
                term: "3–4 hafta",
                best: "AI umuman foyda beradimi degan savolga katta byudjetsiz javob olish",
                features: [
                    "Bitta vazifa: RAG bilimlar bazasi yoki hujjat tahlili",
                    "500 tagacha hujjat yoki sahifa indekslanadi",
                    "Claude API yoki OpenAI API ulash",
                    "pgvector asosidagi vektor baza",
                    "Oddiy veb-interfeys yoki Telegram orqali kirish",
                    "O'zbek va rus tilidagi matnlar bilan ishlash",
                    "Har javobda manba hujjat va sahifa raqami",
                    "100 ta savoldan iborat sifat testi va hisoboti",
                    "Oylik API xarajati bo'yicha real o'lchov",
                    "3 oylik texnik qo'llab-quvvatlash",
                ],
            },
            {
                name: "Standart",
                tagline: "Ishlab chiqarishga tayyor tizim",
                price: "45 000 000",
                priceNote: "so'mdan",
                term: "6–10 hafta",
                best: "Kundalik ishga ulanadigan, CRM va hujjat oqimiga bog'langan yechim",
                featured: true,
                features: [
                    "Pilotdagi hamma narsa",
                    "Cheklanmagan hujjat hajmi, Qdrant yoki pgvector tanlanadi",
                    "Hujjatdan maydon ajratish (shartnoma, hisob-faktura, akt)",
                    "Skanerlangan hujjatlar uchun OCR",
                    "Ovozli murojaatlar uchun Whisper orqali transkripsiya",
                    "CRM, 1C yoki ichki tizim bilan integratsiya",
                    "Rollar va kirish huquqlari — bo'lim bo'yicha ajratilgan",
                    "Admin panel: hujjat yuklash, qayta indekslash, javob tuzatish",
                    "Javob sifati monitoringi va xato javoblarni belgilash",
                    "Xodimlar uchun trening va video qo'llanma",
                    "6 oylik texnik qo'llab-quvvatlash",
                ],
            },
            {
                name: "Korxona",
                tagline: "Yopiq kontur va murakkab modellar",
                price: "Kelishuv",
                priceNote: "asosida",
                term: "3 oydan",
                best: "Ma'lumot kompaniyadan tashqariga chiqmasligi kerak bo'lgan tashkilotlar",
                features: [
                    "O'z serveringizda ishlaydigan ochiq model (Llama, Qwen)",
                    "Bashorat modellari: sotuv, qoldiq, mijoz ketishi",
                    "Katalog uchun tavsiya tizimi va A/B sinovi",
                    "ERP va ombor tizimlariga to'liq ulanish",
                    "Audit jurnali va shaxsiy ma'lumotlarni maskalash",
                    "Yuklamaga chidamlilik testi va SLA",
                    "Modelni davriy qayta o'qitish va sifat nazorati",
                ],
            },
        ],
    },

    process: {
        eyebrow: "Jarayon",
        h: "AI yechim qanday quriladi",
        sub: "Beshta bosqich. Eng ko'p vaqt kodga emas, ma'lumotni tartibga solishga ketadi.",
        steps: [
            {
                t: "Vazifani aniqlash",
                time: "3–5 kun",
                d: "Qaysi ish hozir qo'lda bajarilayotganini, unga qancha vaqt ketayotganini va muvaffaqiyat qanday o'lchanishini yozib olamiz. Agar AI bu yerda foyda bermasa — shuni aytamiz.",
            },
            {
                t: "Ma'lumot auditi",
                time: "1–2 hafta",
                d: "Hujjatlar, bazalar va Excel fayllarni ko'rib chiqamiz. Qaysilari to'liq, qaysilari eskirgan, qaysilari umuman yo'q — hammasi ro'yxatga tushadi va tozalanadi.",
            },
            {
                t: "Prototip",
                time: "2–3 hafta",
                d: "Kichik hajmdagi ma'lumot ustida ishlaydigan versiya quriladi. Siz uni real savollar bilan sinaysiz va davom etish yoki to'xtash haqida qaror qabul qilasiz.",
            },
            {
                t: "Ishlab chiqish va integratsiya",
                time: "3–7 hafta",
                d: "To'liq hajm indekslanadi, CRM va hujjat oqimiga ulanadi, rollar sozlanadi. Har hafta demo ko'rsatiladi, o'zgarish oxirida emas, jarayonda kiritiladi.",
            },
            {
                t: "Ishga tushirish va sozlash",
                time: "davomiy",
                d: "Tizim ishga tushadi, birinchi oyda real savollar tahlil qilinadi. Xato javoblar belgilanadi, prompt va indeks qayta sozlanadi — sifat vaqt o'tishi bilan ko'tariladi.",
            },
        ],
    },

    samples: {
        eyebrow: "Namunalar",
        h: "Biz qurgan yechimlar",
        sub: "Har bir loyihada ma'lumot modeli, integratsiya va interfeys biz tomonimizdan tayyorlangan.",
        cta: "Barcha loyihalar",
        slugs: ["neurotagline", "rememberme", "myyurist", "imtihan"],
    },

    faq: {
        eyebrow: "Savol-javob",
        h: "Ko'p beriladigan savollar",
        sub: "Sun'iy intellekt bo'yicha biz eng ko'p eshitadigan savollar va halol javoblar.",
        items: [
            {
                q: "AI yechim ishlab chiqish qancha turadi?",
                a: "Pilot paket 18 000 000 so'mdan boshlanadi — bu bitta vazifani hal qiladigan, 500 tagacha hujjat bilan ishlaydigan versiya. Ishlab chiqarishga tayyor Standart paket 45 000 000 so'mdan. Bu bir martalik to'lov. Model API'si uchun oylik xarajat alohida: odatda 300 000 so'mdan 4 000 000 so'mgacha, so'rovlar soniga qarab.",
            },
            {
                q: "AI noto'g'ri javob berib qo'ymaydimi?",
                a: "Beradi, va buni yashirmaymiz. Til modellari gallyutsinatsiyaga moyil — ishonchli ohangda noto'g'ri ma'lumot yozishi mumkin. Biz buni uch usulda kamaytiramiz: model faqat sizning hujjatlaringiz doirasida javob beradi, har javobda manba havolasi ko'rsatiladi, mos hujjat topilmasa tizim \"ma'lumot yo'q\" deb javob beradi. Xavf nolga tushmaydi, shuning uchun muhim qarorlar baribir odam tomonidan tasdiqlanadi.",
            },
            {
                q: "AI o'zbek tilini tushunadimi?",
                a: "Ha, Claude va GPT modellari o'zbek tilida yaxshi ishlaydi — lotin va kirill yozuvida, aralash o'zbekcha-ruscha matnda ham. Rus va ingliz tiliga nisbatan sifat biroz pastroq, shuning uchun o'zbekcha hujjatlar uchun test to'plamini alohida tuzamiz va javoblarni qo'lda tekshirib chiqamiz.",
            },
            {
                q: "Qachon AI kerak emas?",
                a: "Agar jarayon qat'iy qoidalar bo'yicha ketsa, oddiy skript yoki formula arzonroq va ishonchliroq bo'ladi. Agar ma'lumot tartibsiz yoki juda kam bo'lsa, model o'rganadigan narsa topmaydi. Oyiga bir necha marta bajariladigan ish uchun ham AI iqtisodiy jihatdan o'zini oqlamaydi. Bunday holatda shuni ochiq aytamiz.",
            },
            {
                q: "Ma'lumotlarim qayerda saqlanadi va xavfsizmi?",
                a: "Standart holatda hujjatlar sizning serveringizda yoki siz tanlagan bulutda saqlanadi, modelga faqat savolga tegishli bo'laklar yuboriladi. Anthropic va OpenAI biznes shartnomalarida API orqali yuborilgan ma'lumot model o'qitishga ishlatilmaydi. Agar hech qanday ma'lumot tashqariga chiqmasligi shart bo'lsa, o'z serveringizda ishlaydigan ochiq modelni o'rnatamiz.",
            },
            {
                q: "RAG nima va nega u kerak?",
                a: "RAG — savolga javob berishdan oldin bilimlar bazasidan mos hujjat bo'laklarini topib, modelga kontekst sifatida beradigan yondashuv. Bu modelni qayta o'qitishdan arzonroq va tezroq: yangi hujjat qo'shsangiz, tizim uni darhol biladi. Shu bilan birga javob manbasi aniq bo'ladi, bu esa gallyutsinatsiyani sezilarli kamaytiradi.",
            },
            {
                q: "Loyiha qancha vaqt oladi?",
                a: "Pilot 3–4 haftada, Standart paket 6–10 haftada topshiriladi. Muddatga eng ko'p ta'sir qiladigan narsa — ma'lumotning holati. Hujjatlar tartibli bo'lsa muddat qisqaradi, turli formatlarda sochilib yotgan bo'lsa audit bosqichi uzayadi. Yana bir omil — sizning tomoningizdan javob beradigan mutaxassis. Agar savollarimizga bir necha kunda javob kelsa, jadval siljiydi. Shuning uchun boshida mas'ul shaxsni kelishib olamiz.",
            },
            {
                q: "Qanday texnologiyalar ishlatiladi?",
                a: "Til modellari uchun Claude API yoki OpenAI API, yopiq kontur kerak bo'lsa o'z serverimizdagi ochiq modellar. Vektor baza sifatida PostgreSQL uchun pgvector yoki alohida Qdrant. Ovozni matnga o'girishda Whisper, skanerlangan hujjatlar uchun OCR. Backend odatda Node.js yoki Python, integratsiyalar REST API orqali.",
            },
            {
                q: "AI xodimlarni ishdan bo'shatadimi?",
                a: "Bizning loyihalarimizda odatda yo'q. AI takroriy ishni oladi: qidirish, ko'chirib yozish, turkumlash. Qaror qabul qilish va mijoz bilan murakkab muloqot odamda qoladi. Ko'proq uchraydigan natija — bir xil jamoa ko'proq hajmni ko'tarishi va qo'shimcha odam yollash ehtiyoji yo'qolishi. Buning o'rniga xodimlar tizimni tekshirish va sifatni nazorat qilish vazifasini oladi.",
            },
            {
                q: "Tizimni keyin o'zim boshqara olamanmi?",
                a: "Ha. Admin panel orqali yangi hujjat yuklaysiz, eskisini o'chirasiz va qayta indekslashni bir tugma bilan ishga tushirasiz. Noto'g'ri javoblarni belgilab qo'yish imkoni ham bor — shu ro'yxat asosida biz keyingi sozlashni bajaramiz. Kod va baza sizniki bo'ladi, hujjatlashtirish ham topshiriladi. Istasangiz keyinchalik boshqa jamoa bilan davom etishingiz mumkin — bog'lanish yo'q.",
            },
        ],
    },

    cta: {
        h: "Qaysi ishingizni AI'ga berish mumkinligini birga aniqlaymiz",
        p: "Bepul konsultatsiyada jarayonlaringizni ko'rib chiqamiz, AI real foyda beradigan joyni ko'rsatamiz va bermaydigan joyini ham aytamiz. Keyin aniq narx va muddat beramiz. Majburiyat yo'q — +998 90 954 12 62.",
        button: "Bepul konsultatsiya olish",
        secondary: "+998 90 954 12 62",
    },

    images: [
        {
            src: "/assets/img/projects/neurotagline.webp",
            alt: "Neurotagline loyihasi — tibbiy ma'lumotlarni tahlil qiluvchi AI yechim interfeysi",
            caption: "Neurotagline — tibbiy matnlarni tahlil qilish uchun qurilgan AI platforma.",
        },
        {
            src: "/assets/img/projects/rememberme.webp",
            alt: "RememberMe platformasi — sun'iy intellekt asosidagi ma'lumot saqlash tizimi",
            caption: "RememberMe — foydalanuvchi ma'lumotlarini saqlash va qidirish tizimi.",
        },
        {
            src: "/assets/img/services/ai-rag-arxitektura.webp",
            alt: "RAG bilimlar bazasi arxitekturasi — hujjat, vektor baza va til modeli bog'lanishi",
            caption: "RAG sxemasi: hujjat bo'laklari vektor bazaga tushadi, model faqat topilgan bo'laklar asosida javob yozadi.",
            prompt:
                "Clean technical architecture diagram on dark background: documents flowing into a chunking step, then into a vector database, then retrieved chunks feeding a language model that outputs an answer with source citation. Minimal flat style, blue and teal accents, English labels, no people.",
        },
        {
            src: "/assets/img/services/ai-hujjat-tahlili.webp",
            alt: "AI hujjat tahlili — shartnomadan maydonlarni avtomatik ajratib olish ekrani",
            caption: "Hujjat tahlili: chap tomonda skanerlangan shartnoma, o'ngda avtomatik ajratilgan maydonlar.",
            prompt:
                "Split-screen software UI mockup: scanned invoice document on the left, automatically extracted structured fields (number, date, amount, counterparty) highlighted on the right with confidence scores. Modern SaaS interface, light theme, blue accents, no real company names.",
        },
    ],

    related: ["ai-agent", "ai-integratsiya", "computer-vision", "crm-tizimlar"],
};

const ru = {
    meta: {
        title: "ИИ-решения для бизнеса — внедрение искусственного интеллекта",
        description:
            "ИИ-решения для бизнеса: анализ документов, прогнозные модели, рекомендательные системы и база знаний на RAG. Цена от 18 млн сум, срок от 3 недель. Innobek, Ташкент.",
        keywords: [
            "ИИ-решения",
            "искусственный интеллект для бизнеса",
            "внедрение ИИ",
            "база знаний RAG",
            "анализ документов ИИ",
            "прогнозная модель",
            "рекомендательная система",
            "стоимость искусственного интеллекта",
            "Claude API",
            "векторная база",
        ],
    },

    hero: {
        eyebrow: "Искусственный интеллект / ИИ-решения",
        h1: "ИИ-решения, которые работают на ваших собственных данных",
        lead:
            "За годы работы в компании накопились договоры, счета, заказы и переписка. Чтобы найти в них нужный ответ, сотрудник тратит часы. ИИ-решение находит его за секунды, показывает источник и честно останавливается там, где данных нет.",
        ctaPrimary: "Получить бесплатную консультацию",
        ctaSecondary: "Посмотреть цены",
        proof: [
            "Команда разработки в Ташкенте",
            "Работаем с Claude API и OpenAI API",
            "Документы на узбекском и русском",
            "Каждый ответ со ссылкой на источник",
            "Начинаем с пилота — без большого бюджета",
        ],
    },

    intro: {
        h: "Что такое ИИ-решение и когда оно действительно окупается",
        p: [
            "Под «искусственным интеллектом» многие понимают только чат-бота. На деле ИИ-решения для бизнеса гораздо шире: извлечение данных из документов, прогноз продаж, рекомендации товаров, поиск ответа во внутренней базе знаний. Каждая из этих задач требует своей архитектуры и своего подхода к данным.",
            "Мы не продаём ИИ как волшебство. Модель не изобретает знания — она работает только с тем, что вы ей дали. Поэтому любой проект начинается со сбора и приведения данных в порядок. Если прайс лежит в пяти разных версиях Excel, ИИ будет отвечать так же противоречиво. Мы говорим об этом заранее, а не в конце.",
            "Самое частое решение — база знаний на RAG (Retrieval-Augmented Generation). Документы режутся на фрагменты, попадают в векторную базу (pgvector или Qdrant), и при каждом вопросе система находит наиболее подходящие фрагменты и передаёт их модели. Ответ строится только на них, а внизу указывается документ и страница.",
            "Второе крупное направление — автоматизация документооборота. Договоры, счета-фактуры, акты и заявления сотрудники переносят в систему руками. ИИ читает текст, вытаскивает нужные поля и записывает их сам. Для бумажных сканов добавляется OCR, для голосовых обращений — расшифровка через Whisper.",
            "Третье — модели, работающие с числами: прогноз продаж, прогноз складских остатков, вероятность оттока клиента, рекомендации для каталога. Здесь применяется не большая языковая модель, а классическое машинное обучение, и результат измеряется в конкретных процентах точности.",
        ],
    },

    definition: {
        term: "Что такое ИИ-решение?",
        text:
            "ИИ-решение — программная система, которая работает на собственных данных компании и выполняет конкретную задачу: анализ документов, прогноз, рекомендации или поиск ответа в базе знаний.",
    },

    included: {
        eyebrow: "Что входит",
        h: "Входит в каждый проект по умолчанию",
        sub: "Это не платные дополнения — всё есть даже в базовом пакете.",
        items: [
            "Постановка задачи: что решает ИИ и как измеряется результат",
            "Аудит данных — какие источники есть, а каких не хватает",
            "Очистка данных и приведение к единому формату",
            "Выбор модели: Claude API, OpenAI API или модель на вашем сервере",
            "Написание промптов и правил ответа, определение границ",
            "Настройка векторной базы (pgvector или Qdrant) и индексация",
            "Тестовый набор для проверки качества — не менее 100 вопросов",
            "Защита от галлюцинаций: ссылки на источник и ответ «не знаю»",
            "Подключение к вашим системам: сайт, CRM, 1С или внутренняя панель",
            "Админ-панель — обновление документов и проверка ответов",
            "Инструкция для сотрудников и обучение при запуске",
            "Реальный замер и прогноз месячного расхода на API",
            "6 месяцев технической поддержки после запуска",
        ],
    },

    benefits: {
        eyebrow: "Зачем это нужно",
        h: "Что искусственный интеллект даёт бизнесу",
        sub: "Не абстрактная экономия времени, а измеримый результат. Ниже — что реально работает.",
        items: [
            {
                t: "Поиск ответа занимает секунды",
                d: "В компаниях с большой внутренней базой сотрудник ищет нужный пункт 10–30 минут. С системой на RAG это 10–20 секунд, причём под ответом стоит ссылка на источник — сотрудник может перепроверить сам.",
            },
            {
                t: "Ввод документов перестаёт быть ручным",
                d: "Перенос полей из счёта или договора занимает 5–15 минут на документ. ИИ делает это за 10–20 секунд с точностью обычно 90–97%. Остальное подтверждает человек, поэтому экран проверки в системе обязателен.",
            },
            {
                t: "Прогноз опирается на цифры",
                d: "Планирование продаж и закупок часто держится на интуиции менеджера. Модель берёт сезонность и тренд из истории за 2–3 года. В реальных проектах ошибка составляет 10–25% — это не точное знание, но для плана закупок достаточно.",
            },
            {
                t: "Рекомендации поднимают средний чек",
                d: "Если в каталоге больше тысячи позиций, клиент смотрит три-четыре страницы и уходит. Блок рекомендаций на основе истории покупок обычно даёт прирост среднего чека на 5–15%. Точная цифра зависит от качества каталога и трафика.",
            },
            {
                t: "Знания остаются в системе, а не в голове",
                d: "Уходит опытный сотрудник — уходят и его знания. Регламенты, договорённости и нестандартные случаи, записанные в базу знаний, остаются в компании. Новичок спрашивает у ИИ и не отвлекает коллег.",
            },
            {
                t: "Расходы понятны заранее",
                d: "Разработка оплачивается один раз, расход на API — ежемесячно и зависит от числа запросов. На пилоте мы замеряем реальный объём и называем месячную сумму в сумах. Неожиданных счетов не возникает.",
            },
            {
                t: "Можно начать с малого",
                d: "Внедрять ИИ сразу по всей компании необязательно. Начинаем с одного отдела и одной задачи, результат виден через три-четыре недели. Если не сработает, потери ограничены 18 миллионами сум, а не сотнями миллионов.",
            },
        ],
    },

    audience: {
        eyebrow: "Кому подходит",
        h: "Какие компании заказывают ИИ-решения",
        sub: "Общее правило: много данных, много повторяющейся работы и высокая цена ошибки.",
        items: [
            {
                t: "Юридические и консалтинговые компании",
                d: "Большой архив договоров и нормативных документов. ИИ находит нужный пункт, готовит выжимку и показывает источник.",
            },
            {
                t: "Торговля и дистрибуция",
                d: "Прогноз остатков, план закупок и рекомендации для каталога. Здесь эффект измеряется прямо в деньгах.",
            },
            {
                t: "Клиники и лаборатории",
                d: "Структурирование карт пациентов и результатов анализов, внутренний поиск по протоколам. Диагноз на ИИ не перекладывается.",
            },
            {
                t: "Логистика и доставка",
                d: "Автоматическое чтение товаросопроводительных документов, прогноз сроков и классификация обращений клиентов.",
            },
            {
                t: "Финансы и бухгалтерские услуги",
                d: "Распознавание счетов, категоризация транзакций и пометка нетипичных операций для проверки.",
            },
            {
                t: "Образование и HR-отделы",
                d: "База знаний по внутренним регламентам, первичный отбор резюме, автоматическая проверка тестов.",
            },
            {
                t: "Производственные предприятия",
                d: "Поиск по документации на оборудование и техническим регламентам, прогноз сроков обслуживания по истории отказов.",
            },
        ],
    },

    pricing: {
        eyebrow: "Цены",
        h: "Стоимость ИИ-решения — три пакета",
        sub: "Разработка оплачивается один раз. Расход на API — отдельно и ежемесячно.",
        note:
            "Цены указаны на 2026 год, итоговая смета подтверждается после бесплатной консультации. Ежемесячный расход на API модели считается отдельно: при небольшом объёме (200–500 запросов в день) это примерно 300 000 – 1 200 000 сум, при среднем — 1 500 000 – 4 000 000 сум. Эти деньги платятся напрямую провайдеру (Anthropic или OpenAI), мы не добавляем к ним процент. На пилоте замеряем реальный объём и называем точную сумму.",
        tiers: [
            {
                name: "Пилот",
                tagline: "Одна конкретная задача, быстрый результат",
                price: "18 000 000",
                priceNote: "сум",
                term: "3–4 недели",
                best: "Проверить, даёт ли ИИ пользу, без большого бюджета",
                features: [
                    "Одна задача: база знаний на RAG или анализ документов",
                    "Индексация до 500 документов или страниц",
                    "Подключение Claude API или OpenAI API",
                    "Векторная база на pgvector",
                    "Простой веб-интерфейс или доступ через Telegram",
                    "Работа с текстами на узбекском и русском",
                    "В каждом ответе документ-источник и номер страницы",
                    "Тест качества из 100 вопросов и отчёт по нему",
                    "Реальный замер месячного расхода на API",
                    "3 месяца технической поддержки",
                ],
            },
            {
                name: "Стандарт",
                tagline: "Система, готовая к промышленной работе",
                price: "45 000 000",
                priceNote: "сум",
                term: "6–10 недель",
                best: "Решение, встроенное в ежедневную работу, CRM и документооборот",
                featured: true,
                features: [
                    "Всё, что входит в пакет «Пилот»",
                    "Без ограничения по объёму документов, Qdrant или pgvector",
                    "Извлечение полей из документов (договор, счёт, акт)",
                    "OCR для отсканированных документов",
                    "Расшифровка голосовых обращений через Whisper",
                    "Интеграция с CRM, 1С или внутренней системой",
                    "Роли и права доступа с разделением по отделам",
                    "Админ-панель: загрузка документов, переиндексация, правка ответов",
                    "Мониторинг качества ответов и пометка ошибочных",
                    "Обучение сотрудников и видеоинструкция",
                    "6 месяцев технической поддержки",
                ],
            },
            {
                name: "Корпоративный",
                tagline: "Закрытый контур и сложные модели",
                price: "По договору",
                priceNote: "",
                term: "от 3 месяцев",
                best: "Организациям, где данные не должны покидать периметр компании",
                features: [
                    "Открытая модель на вашем сервере (Llama, Qwen)",
                    "Прогнозные модели: продажи, остатки, отток клиентов",
                    "Рекомендательная система для каталога и A/B-тестирование",
                    "Полная интеграция с ERP и складскими системами",
                    "Журнал аудита и маскирование персональных данных",
                    "Нагрузочное тестирование и SLA",
                    "Периодическое переобучение модели и контроль качества",
                ],
            },
        ],
    },

    process: {
        eyebrow: "Процесс",
        h: "Как создаётся ИИ-решение",
        sub: "Пять этапов. Больше всего времени уходит не на код, а на приведение данных в порядок.",
        steps: [
            {
                t: "Постановка задачи",
                time: "3–5 дней",
                d: "Фиксируем, какая работа сейчас делается руками, сколько времени занимает и как будет измеряться успех. Если ИИ здесь не даёт выгоды — мы скажем об этом прямо.",
            },
            {
                t: "Аудит данных",
                time: "1–2 недели",
                d: "Разбираем документы, базы и Excel-файлы. Что полное, что устарело, чего нет вовсе — всё попадает в список и приводится в порядок.",
            },
            {
                t: "Прототип",
                time: "2–3 недели",
                d: "Собираем работающую версию на небольшом объёме данных. Вы проверяете её реальными вопросами и принимаете решение — продолжать или остановиться.",
            },
            {
                t: "Разработка и интеграция",
                time: "3–7 недель",
                d: "Индексируем полный объём, подключаем CRM и документооборот, настраиваем роли. Демо показываем еженедельно, правки вносим по ходу, а не в конце.",
            },
            {
                t: "Запуск и донастройка",
                time: "постоянно",
                d: "Система запускается, и первый месяц мы разбираем реальные вопросы. Ошибочные ответы помечаются, промпты и индекс перенастраиваются — качество растёт со временем.",
            },
        ],
    },

    samples: {
        eyebrow: "Примеры",
        h: "Решения, которые мы создали",
        sub: "В каждом проекте модель данных, интеграции и интерфейс сделаны нашей командой.",
        cta: "Все проекты",
        slugs: ["neurotagline", "rememberme", "myyurist", "imtihan"],
    },

    faq: {
        eyebrow: "Вопросы и ответы",
        h: "Частые вопросы",
        sub: "Что чаще всего спрашивают про искусственный интеллект — и честные ответы.",
        items: [
            {
                q: "Сколько стоит разработка ИИ-решения?",
                a: "Пакет «Пилот» начинается от 18 000 000 сум — это решение одной задачи на объёме до 500 документов. Готовый к промышленной работе «Стандарт» — от 45 000 000 сум. Это разовая оплата. Расход на API модели считается отдельно и обычно составляет от 300 000 до 4 000 000 сум в месяц в зависимости от числа запросов.",
            },
            {
                q: "Не будет ли ИИ отвечать неправильно?",
                a: "Будет, и мы это не скрываем. Языковые модели склонны к галлюцинациям — уверенным тоном выдавать неверную информацию. Мы снижаем риск тремя способами: модель отвечает только в рамках ваших документов, под каждым ответом стоит ссылка на источник, а при отсутствии подходящего фрагмента система отвечает «данных нет». До нуля риск не падает, поэтому важные решения всё равно подтверждает человек.",
            },
            {
                q: "Понимает ли ИИ узбекский язык?",
                a: "Да, модели Claude и GPT неплохо работают с узбекским — и на латинице, и на кириллице, и в смешанном узбекско-русском тексте. Качество чуть ниже, чем на русском и английском, поэтому для узбекских документов мы собираем отдельный тестовый набор и проверяем ответы вручную.",
            },
            {
                q: "Когда искусственный интеллект не нужен?",
                a: "Если процесс идёт по жёстким правилам, обычный скрипт или формула дешевле и надёжнее. Если данных мало или они хаотичны, модели просто не на чем учиться. Для работы, которая выполняется несколько раз в месяц, ИИ экономически не окупается. В таких случаях мы говорим об этом открыто.",
            },
            {
                q: "Где хранятся мои данные и безопасно ли это?",
                a: "По умолчанию документы лежат на вашем сервере или в выбранном вами облаке, а модели передаются только фрагменты, относящиеся к вопросу. По бизнес-условиям Anthropic и OpenAI данные, переданные через API, не используются для обучения моделей. Если требуется, чтобы данные вообще не покидали компанию, ставим открытую модель на ваш сервер.",
            },
            {
                q: "Что такое RAG и зачем он нужен?",
                a: "RAG — подход, при котором система сначала находит подходящие фрагменты в базе знаний и передаёт их модели как контекст, и только потом формирует ответ. Это дешевле и быстрее дообучения модели: добавили новый документ — система уже знает его. Заодно источник ответа становится прозрачным, а галлюцинаций заметно меньше.",
            },
            {
                q: "Сколько времени занимает проект?",
                a: "Пилот сдаётся за 3–4 недели, «Стандарт» — за 6–10 недель. Сильнее всего на срок влияет состояние данных. Если документы упорядочены, срок сокращается; если они разбросаны по разным форматам, этап аудита удлиняется. Второй фактор — ответственный с вашей стороны. Когда ответы на наши вопросы приходят через несколько дней, график сдвигается, поэтому мы согласовываем контактное лицо на старте.",
            },
            {
                q: "Какие технологии используются?",
                a: "Для языковых моделей — Claude API или OpenAI API, для закрытого контура — открытые модели на собственном сервере. В качестве векторной базы pgvector для PostgreSQL или отдельный Qdrant. Для речи — Whisper, для сканов — OCR. Бэкенд обычно на Node.js или Python, интеграции через REST API.",
            },
            {
                q: "Приведёт ли внедрение ИИ к сокращению сотрудников?",
                a: "В наших проектах обычно нет. ИИ забирает повторяющуюся работу: поиск, перенос данных, классификацию. Принятие решений и сложное общение с клиентом остаются за человеком. Чаще встречается другой результат: та же команда справляется с большим объёмом, и потребность в новых наймах отпадает.",
            },
            {
                q: "Смогу ли я сам управлять системой потом?",
                a: "Да. Через админ-панель вы загружаете новые документы, удаляете устаревшие и запускаете переиндексацию одной кнопкой. Неверные ответы можно помечать — по этому списку мы проводим следующую донастройку. Код, база данных и документация остаются вашими. При желании вы сможете продолжить с другой командой — привязки к нам нет.",
            },
        ],
    },

    cta: {
        h: "Давайте вместе определим, какую работу можно отдать ИИ",
        p: "На бесплатной консультации разберём ваши процессы, покажем, где искусственный интеллект даст реальную пользу, и честно скажем, где не даст. Затем назовём точную цену и срок. Без обязательств — +998 90 954 12 62.",
        button: "Получить бесплатную консультацию",
        secondary: "+998 90 954 12 62",
    },

    images: [
        {
            src: "/assets/img/projects/neurotagline.webp",
            alt: "Проект Neurotagline — интерфейс ИИ-решения для анализа медицинских данных",
            caption: "Neurotagline — платформа на базе ИИ для анализа медицинских текстов.",
        },
        {
            src: "/assets/img/projects/rememberme.webp",
            alt: "Платформа RememberMe — система хранения данных на основе искусственного интеллекта",
            caption: "RememberMe — система хранения и поиска пользовательских данных.",
        },
        {
            src: "/assets/img/services/ai-rag-arxitektura.webp",
            alt: "Архитектура базы знаний RAG — документы, векторная база и языковая модель",
            caption: "Схема RAG: фрагменты документов попадают в векторную базу, модель отвечает только по найденным фрагментам.",
            prompt:
                "Clean technical architecture diagram on dark background: documents flowing into a chunking step, then into a vector database, then retrieved chunks feeding a language model that outputs an answer with source citation. Minimal flat style, blue and teal accents, English labels, no people.",
        },
        {
            src: "/assets/img/services/ai-hujjat-tahlili.webp",
            alt: "Анализ документов с помощью ИИ — автоматическое извлечение полей из договора",
            caption: "Анализ документов: слева отсканированный счёт, справа автоматически извлечённые поля.",
            prompt:
                "Split-screen software UI mockup: scanned invoice document on the left, automatically extracted structured fields (number, date, amount, counterparty) highlighted on the right with confidence scores. Modern SaaS interface, light theme, blue accents, no real company names.",
        },
    ],

    related: ["ai-agent", "ai-integratsiya", "computer-vision", "crm-tizimlar"],
};

const content = { uz, ru };

export default content;
